import React, { useContext } from 'react';
import './LocationSection.css';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import leaflet from "leaflet";
import { LanguageContext } from '../context/LanguageContext';


const markerIcon = new leaflet.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});


const posicion = {
  lat: 37.17205, 
  lng: -3.60101, 
};

const LocationSection = () => {
  const {t} = useContext(LanguageContext);
  return (
    <section className="location-section">
      <div className="location-header">
        <h2 className="location-title">{t("location","title")}</h2>
        <p className="location-description">
          {t("location","subtitle")}
        </p>
      </div>

      <div className="location-map">
        <MapContainer
          center={[posicion.lat, posicion.lng]}
          zoom={16}
          scrollWheelZoom={false}
          className='map-container'
        >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='© OpenStreetMap contributors'
        />

        <Marker position={[posicion.lat, posicion.lng]} icon={markerIcon}>
          <Popup>
            Calle San José Baja 6<br />
            Granada, España
          </Popup>
        </Marker>
      </MapContainer>
      </div>
    </section>
  );
};

export default LocationSection;